import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=27f93f72&scoped=true&"
import script from "./OrderError.vue?vue&type=script&lang=js&"
export * from "./OrderError.vue?vue&type=script&lang=js&"
import style0 from "./OrderError.vue?vue&type=style&index=0&id=27f93f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f93f72",
  null
  
)

component.options.__file = "OrderError.vue"
export default component.exports